import * as actionTypes from './actionTypes';
import axios from '../../services/axios'
import { mapTree } from '../../services/generalService';
import { setMessage } from './message';

export const loadDepartmentsTree = () => {
    return {
        type: actionTypes.LOAD_DEPARTMENTS_TREE
    }
}

export const setDepartmentsTree = (departmentsTreeData) => {
    return {
        type: actionTypes.SET_DEPARTMENTS_TREE,
        departmentsData: departmentsTreeData.filter(el => el.data.code !== null)
    }
}

export const getDepartmentsTree = () => {
    return (dispatch) => {
        dispatch(loadDepartmentsTree())
        axios.get('/api/v1/departments/tree')
            .then(response => {
                mapTree(response.data)
                dispatch(setDepartmentsTree(response.data))
            })
            .catch(error => {
                dispatch(setDepartmentsTree([]))
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
            });
    }
}

